@if (linkUser) {
  <div
    role="alert"
    class="alert alert-warning"
    [innerHTML]="'AbpAccount::LinkAccountWarning' | abpLocalization: '/account/login'"
  ></div>
}

@if (isSelfRegistrationEnabled) {
  <h5 class="mb-2">
    {{ 'AbpAccount::NotAMemberYet' | abpLocalization }}
    <a routerLink="/account/register" queryParamsHandling="preserve" class="text-decoration-none">
      {{ 'AbpAccount::Register' | abpLocalization }}
    </a>
  </h5>
}


<form [formGroup]="form" (ngSubmit)="onSubmit()" validateOnSubmit>
  <div class="form-floating mb-2">
    <input
      autofocus
      type="text"
      id="login-input-user-name-or-email-address"
      class="form-control"
      formControlName="username"
      placeholder="name@example.com"
    />
    <label for="login-input-user-name-or-email-address">
      {{ 'AbpAccount::UserNameOrEmailAddress' | abpLocalization }}
    </label>
  </div>

  <div class="form-floating mb-2">
    <input
      id="password"
      class="form-control"
      placeholder="Password"
      formControlName="password"
      (abpCapsLock)="capsLock = $event"
      [abpShowPassword]="showPassword"
    />
    <label for="floatingPassword">{{ 'AbpAccount::Password' | abpLocalization }}</label>
    <i
      id="capslockicon"
      class="bi bi-capslock caps-lock-icon"
      [class.d-none]="!capsLock"
      [ngbTooltip]="'AbpAccount::CapsLockOn' | abpLocalization"
    ></i>

    <i
      id="passwordicon"
      class="bi bi-eye{{ showPassword ? '' : '-slash' }} show-pass-icon"
      aria-label="Show/Hide password"
      (click)="showPassword = !showPassword"
      [ngbTooltip]="
        'AbpAccount::' + (!showPassword ? 'ShowPassword' : 'HidePassword') | abpLocalization
      "
    ></i>
  </div>

  <div class="row mb-3">
    <div class="col">
      <div class="form-check form-switch">
        <input
          class="form-check-input"
          type="checkbox"
          id="rememberMe"
          formControlName="rememberMe"
        />
        <label class="form-check-label" for="rememberMe">
          {{ 'AbpAccount::RememberMe' | abpLocalization }}
        </label>
      </div>
      @if (isBiometricAvailable) {
        <div class="form-check form-switch">
          <input
            class="form-check-input"
            type="checkbox"
            id="useBiometricLogin"
            [(ngModel)]="useBiometricLogin"
            (ngModelChange)="onBiometricCheckboxChange()"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="inProgress"
          />
          <label class="form-check-label" for="useBiometricLogin">
            Habilitar acesso com biometria
          </label>
        </div>
      }
    </div>

    <div class="col text-end">
      <a class="text-decoration-none" routerLink="/account/forgot-password">
        {{ 'AbpAccount::ForgotPassword' | abpLocalization }}
      </a>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div #recaptcha></div>
      <abp-button
        class="d-grid"
        buttonClass="mt-2 mb-3 btn btn-primary btn-lg"
        [loading]="inProgress"
        buttonType="submit"
      >
        <i class="bi bi-box-arrow-in-right me-1"></i> {{ 'AbpAccount::Login' | abpLocalization }}
      </abp-button>
    </div>
  </div>
</form>

<div class="privacy-policy">
    <a (click)="openPrivacyPolicies()">Política de privacidade</a>
</div>
